import React, { useState, useEffect } from 'react';
import { Tags } from 'lucide-react';
import ModalBtn from '../../molecules/modalButton/view';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import { createSpendType, updateSpendType, deleteSpendType } from '../../../usecases/spend-type-usecase';
import SpendTypeForm from '../SpendTypeForm/view';

function NewSpendType({
    id = '',
    onSuccess,
    hideButton = false,
    initialData = null,
    writeMode = 'create',
    writeId = null,
}) {
    const [resetKey, setResetKey] = useState(0);
    const [currentInitialData, setCurrentInitialData] = useState(initialData);

    useEffect(() => {
        setCurrentInitialData(initialData);
    }, [initialData]);

    const isEdit = writeMode === 'edit' || !!currentInitialData;
    const targetId = writeId || currentInitialData?.id;

    function handleSubmit(payload) {
        if (isEdit && targetId) {
            updateSpendType(targetId, payload)
                .then((res) => {
                    dispatchCustomEvent('close-newSpendType-' + id + '-modal', []);
                    dispatchCustomEvent('modal-close-newSpendType-' + id, []);
                    dispatchCustomEvent('popup', {
                        message: 'Tipo de Gasto actualizado correctamente',
                        type: 'info',
                    });
                    dispatchCustomEvent('reload-spend-types', res);
                    dispatchCustomEvent('loading-btn-spend-type-create', null);
                    setResetKey(prev => prev + 1);
                    if (onSuccess) onSuccess(res, 'update');
                })
                .catch((error) => {
                    const err = error.response?.data?.error;
                    const messages = {
                        bad_request: 'Solicitud inválida. Verifique los datos.',
                        'SpendType name must be unique for the given user.': 'Ya existe un tipo de gasto con este nombre.',
                    };
                    dispatchCustomEvent('popup', {
                        message: messages[err] || 'Error al actualizar tipo de gasto',
                        type: 'error',
                    });
                    dispatchCustomEvent('loading-btn-spend-type-create', null);
                });
        } else {
            createSpendType(payload)
                .then((res) => {
                    dispatchCustomEvent('close-newSpendType-' + id + '-modal', []);
                    dispatchCustomEvent('modal-close-newSpendType-' + id, []);
                    dispatchCustomEvent('popup', {
                        message: 'Tipo de Gasto creado correctamente',
                        type: 'success',
                    });
                    dispatchCustomEvent('reload-spend-types', res);
                    dispatchCustomEvent('loading-btn-spend-type-create', null);
                    setResetKey(prev => prev + 1);
                    if (onSuccess) onSuccess(res, 'create');
                })
                .catch((error) => {
                    const err = error.response?.data?.error;
                    const messages = {
                        bad_request: 'Solicitud inválida. Verifique los datos.',
                        'SpendType name must be unique for the given user.': 'Ya existe un tipo de gasto con este nombre.',
                    };
                    dispatchCustomEvent('popup', {
                        message: messages[err] || 'Error al guardar tipo de gasto',
                        type: 'error',
                    });
                    dispatchCustomEvent('loading-btn-spend-type-create', null);
                });
        }
    }

    function handleDelete() {
        if (!targetId) return;
        deleteSpendType(targetId)
            .then(() => {
                dispatchCustomEvent('close-newSpendType-' + id + '-modal', []);
                dispatchCustomEvent('modal-close-newSpendType-' + id, []);
                dispatchCustomEvent('popup', { message: 'Tipo de Gasto eliminado correctamente', type: 'info' });
                dispatchCustomEvent('reload-spend-types', null);
                dispatchCustomEvent('loading-btn-spend-type-create', null);
                if (onSuccess) onSuccess(null, 'delete');
            })
            .catch((error) => {
                console.error('Error deleting spend type:', error);
                dispatchCustomEvent('popup', { message: 'Error al eliminar tipo de gasto', type: 'error' });
                dispatchCustomEvent('loading-btn-spend-type-create', null);
            });
    }

    return (
        <ModalBtn
            id={'newSpendType-' + id}
            title={isEdit ? "Editar Tipo de Gasto" : "Nuevo Tipo de Gasto"}
            icon={<Tags size={20} />}
            hidden={hideButton}
            style={{ border: 'none', width: '780px', maxWidth: '95vw' }}
        >
            <SpendTypeForm
                key={`${resetKey}-${targetId || 'new'}`}
                initialData={currentInitialData}
                onSubmit={handleSubmit}
                loadingId="spend-type-create"
                title={isEdit ? `Editar Tipo de Gasto: ${currentInitialData?.name || ''}` : "Crear Tipo de Gasto"}
                submitLabel={isEdit ? "Guardar Cambios" : "Crear Tipo de Gasto"}
                showDelete={isEdit}
                onDelete={handleDelete}
            />
        </ModalBtn>
    );
}

export default NewSpendType;
